if(!customElements.get('product-main')) {
  class ProductMain extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.section;
      this.productData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
      this.variantsElement = this.querySelector('product-variants');
      this.productTopInfoDesktop = this.querySelector('.main-product-info-desktop');
      this.productTopInfoMobile = this.querySelector('.main-product-info-mobile');
      this.productTabsSection = document.querySelector('.product-tabs');
      this.wrapSelector = this.querySelector('.box-selector');
      this.productColorSelector = this.querySelector('.product-colors');
      this.variantStyleNumberSelector = this.querySelector('.style-number');
      this.variantColorSwatches = this.querySelector('.color-swatches');
      this.productPreorderNotification = this.productData.ProductPreOrderNotification;
      this.variantsPreOrderNotification = this.productData.variantsPreOrderNotification;
      this.variantsHideCTA = this.productData.variantsHideCTA;
      this.elPreOrderNotification = this.querySelector('.important-info .pre-order-notification');
      this.stickyAddToCart = this.querySelector('sticky-add-to-cart');
      
      

      // Move title, price and rewards to the top of the page on mobile
      /*
      if(this.productTopInfoDesktop && this.productTopInfoMobile){
        this.moveProductTopInfo();
        window.addEventListener('mediaChange', this.moveProductTopInfo.bind(this));
      }
      */

      if(this.productTabsSection){
        this.querySelectorAll('.bottom-links a.link-section').forEach((item) => {
          item.addEventListener('click', (e)=>{
            $s.scrollToElement(this.productTabsSection)
            this.productTabsSection.querySelector(`button[data-tab-handle="${item.getAttribute('href').replace('#','')}"]`).click();
          })
        })

        this.querySelectorAll('.bottom-links a.openImagePopUp').forEach((item) => {
          item.addEventListener('click', (e)=>{
            e.preventDefault();
            var imageSrc = item.getAttribute('href');
           
              $s.openModal(`<div class="product-image-popup"><img src="${imageSrc}" alt=""></div>`, 'product-tab-popup'); 
           
          })
        });
      }

      if(this.wrapSelector){
        var radios = this.wrapSelector.querySelectorAll('input[type="radio"]');
        radios.forEach((item)=>{
          item.addEventListener('change', ()=>{
            console.log(this.wrapSelector.querySelector('input[type="radio"]:checked').value + "--------")
            this.wrapSelector.querySelector('input[name="id[]"]').value = this.wrapSelector.querySelector('input[type="radio"]:checked').value;
          })
        })
      }

      if(this.productColorSelector){
        var optionNameSelector = this.productColorSelector.querySelector('.option-name .color-name');
        var defaultOptionName = this.productColorSelector.querySelector('.swatch.selected').getAttribute('title');
        this.productColorSelector.querySelectorAll('.swatch').forEach((item)=>{
          hoverintent(item,
            ()=>{
              optionNameSelector.innerHTML = item.getAttribute('title');
            },
            ()=>{
              optionNameSelector.innerHTML = defaultOptionName;
            }
          )
        })
      }


      this.addEventListener('variantChange', this.onVariantChange.bind(this));

      this.loadSwymCallbackFN();

      if(document.querySelector('.tingle-modal.product-quick-view')){
        if(typeof _swat == 'object') {
          _swat.initializeActionButtons('.tingle-modal.product-quick-view product-main');
        }
      }

    }

    loadSwymCallbackFN(){
      function swymCallbackFn(swat) {
        // your API calls go here
        // detect variant change event
        // Based on your theme code - this event detection may be different - this is only a SAMPLE implementation
        document.addEventListener("variantChange", function(event) {
            var variantId = event.detail.variant.id; /* the current selected variant id */
            window.triggerSwymVariantEvent(variantId);
            swat.initializeActionButtons(".product-page-wishlist-grid");/* parent container of the where the button is rendered */
        });
      }
      if (!window.SwymCallbacks) {
          window.SwymCallbacks = [];
      }
      window.SwymCallbacks.push(swymCallbackFn);
      /* Called when swym is loaded! */
    }


    preOrderNotification(variantId){
      var elPreOrderNotification = this.elPreOrderNotification;

      var productHasPreOrderNotification = false;
      if(this.productPreorderNotification){
        if (this.productPreorderNotification.length > 0) {
          productHasPreOrderNotification = true;
        }
      }

      var variantPreOrderNotificationFound = false;
      if(this.productPreorderNotification){
        this.variantsPreOrderNotification.forEach(function(variant){
          if (variant.id === variantId && variant.preOrderNotification.length > 0) {
            elPreOrderNotification.classList.remove('hide');
            elPreOrderNotification.innerHTML = variant.preOrderNotification;
            elPreOrderNotification.setAttribute("data-test", variant.preOrderNotification);
            variantPreOrderNotificationFound = true;
            document.querySelector('.btn.add').innerHTML = document.querySelector('.btn.add').innerHTML.replace("ADD TO BAG","PRE-ORDER");        
          }
        });
      }  
      if (!variantPreOrderNotificationFound) {
        if (productHasPreOrderNotification) {
          elPreOrderNotification.classList.remove('hide');
          elPreOrderNotification.innerHTML = this.productPreorderNotification;
          elPreOrderNotification.setAttribute("data-test", this.productPreorderNotification);
        }else{
          elPreOrderNotification.classList.add('hide');
          document.querySelector('.btn.add').innerHTML = document.querySelector('.btn.add').innerHTML.replace("PRE-ORDER","ADD TO BAG");        
        }
      }
    }

    onVariantChange(event){
      if(document.querySelector(".images-wrapper") && document.querySelector(`.images-wrapper .image-wrap[data-media-name*='${event.detail.variant.sku}']`)){
        console.log(event.detail.variant.sku);
        document.querySelectorAll(".images-wrapper .image-wrap").forEach((e)=>{e.classList.remove("active");});
        document.querySelector(`.images-wrapper .image-wrap[data-media-name*='${event.detail.variant.sku}']`).classList.add("active");
      }
      var title =  event.detail.variant.title;
      title = title.replace(/\s/g, '');
      title = title.replace('$','');
      title = title.replace('.','-');
      title = title.replace('/', '-');
      title = title.replace("''",'');


      var stock = `.variant-stock.variant-${title}`;
      var threshold = `.variant-threshold.variant-${title}`;
     
      if(document.querySelector(stock)){
        var currentStock = parseInt(document.querySelector(stock).innerHTML);
        var currentThreshold = parseInt(document.querySelector(threshold).innerHTML);
        if(currentThreshold >= currentStock){
          setTimeout(() => {
            this.querySelector(".btn.add").style.display = "none";
            this.querySelector(".sold-out-message").style.display = "block";
          }, 200);
        }else{
          this.querySelector('.btn.add').style.display = "block";
        }

      }else{
        this.querySelector('.btn.add').style.display = "block";
      }

 
      if(this.variantStyleNumberSelector){
        this.variantStyleNumberSelector.innerHTML = ``;
        if(event.detail.variant.sku){
          this.variantStyleNumberSelector.innerHTML = `Style #${event.detail.variant.sku}`;
        }
      }
      if(this.variantColorSwatches){
        let chequedColorInput = this.variantColorSwatches.querySelector('input:checked');
        if(chequedColorInput){
          this.variantColorSwatches.querySelector('.color-name').innerHTML = chequedColorInput.value;
        }
      }
      if(this.elPreOrderNotification){
        this.preOrderNotification(event.detail.variant.id);
      }
      if (this.variantsHideCTA){
        if (this.variantsHideCTA.length > 0) {
          this.variantsHideCTA.forEach(variant => {
            if (variant.id == event.detail.variant.id && variant.hideCTA == 'true') {
              document.querySelector('.btn.add').style.display = "none";
            }
          })
        }
      }

      // wishlist - save by variant
      // updates wishlist button data attributes on variant change (pdp and quick view)
      try {
        var currentVariant = event && event.detail && event.detail.variant ? event.detail.variant : null;
        if (currentVariant && currentVariant.id) {
          var wishlistButtons = this.querySelectorAll('.wishlist-btn');
          if (wishlistButtons && wishlistButtons.length) {
            wishlistButtons.forEach(function(btn){
              var currentProductUrl = btn.getAttribute('data-product-url') || '';
              var baseProductUrl = currentProductUrl.split('?')[0];
              btn.setAttribute('data-variant-id', String(currentVariant.id));
              btn.setAttribute('data-product-url', baseProductUrl + '?variant=' + String(currentVariant.id));
            });
          }
          if (typeof _swat === 'object' && _swat.initializeActionButtons) {
            _swat.initializeActionButtons('body');
          }
        }
      } catch(err) {}

      if(this.stickyAddToCart) {
        setTimeout(() => {
          const container = this.querySelector("add-to-cart-form form product-buttons");
          const newDiv = this.querySelector("#cloned");
          
          newDiv.innerHTML = '';

          Array.from(container.children).forEach(child => {
            const clone = child.cloneNode(true);
            newDiv.appendChild(clone);
          });
          
          const buttonSubmit = this.querySelector('sticky-add-to-cart button[type="submit"]:not([disabled])');
          buttonSubmit.addEventListener('click', function() {
            document.querySelector('.shopify-product-form product-buttons button.btn.add').click();
          });
          const mainATC = document.querySelector('.main-product-info .buttons-wishlist')
          const atcOrig = document.querySelector('.main-product-info .mandatory-option-btn')
          const selectVariant = this.querySelector('sticky-add-to-cart .mandatory-option-btn');
          selectVariant.removeAttribute('disabled');

          selectVariant.addEventListener('click', function() {
            const header = document.querySelector('#header');
            const headerHeight = header.offsetHeight;
            const targetElement = document.querySelector('product-variants');
            const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;
            const mandatoryOptionErrorMessage = document.querySelector('.mandatory-option-error');
            if(!atcOrig.classList.contains('hide')){
              window.scrollTo({ top: targetPosition, behavior: 'smooth' });
              if(mandatoryOptionErrorMessage){
                mandatoryOptionErrorMessage.classList.remove('hide');
              }
            }else{
              document.querySelector('.shopify-product-form product-buttons button.btn.add').click();
            }
          });

          // debounce scroll eventListener
            function debounceX(func, wait = 10, immediate = true) {
              let timeout;
              return function() {
                let context = this, args = arguments;
                let later = function() {
                  timeout = null;
                  if (!immediate) func.apply(context, args);
                };
                let callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
              };
            };

            function isMobile() {
              const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
              return regex.test(navigator.userAgent);
            }

            function isScrolledIntoView(el) {
              var rect = el.getBoundingClientRect();
              var elemTop = rect.top;
              var elemBottom = rect.bottom;
          
              // Only completely visible elements return true:
              var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
              // Partially visible elements return true:
              //isVisible = elemTop < window.innerHeight && elemBottom >= 0;
              return isVisible;
          }

            // check position 
            function checkScrollPosition() {
              if(isScrolledIntoView(mainATC)){
                watchedEL.classList.add('hide');
              }else{
                watchedEL.classList.remove('hide');
              }
            }
            //  add listener
            const watchedEL = this.querySelector('sticky-add-to-cart');
            window.addEventListener('scroll', debounceX(checkScrollPosition));

        }, 200);
      }
    }

    moveProductTopInfo(){
      if($s.media.isSmall && this.productTopInfoMobile.innerHTML.length <= 0){
        this.productTopInfoMobile.innerHTML = this.productTopInfoDesktop.innerHTML;
        this.productTopInfoDesktop.innerHTML = '';
        return false;
      }
      if($s.media.isMediumUp && this.productTopInfoDesktop.innerHTML.length <= 0){
        this.productTopInfoDesktop.innerHTML = this.productTopInfoMobile.innerHTML;
        this.productTopInfoMobile.innerHTML = '';
      }
    }

    getCurrentVariant() {
      return this.variantsElement.getCurrentVariant();
    }
    getQuantity() {
      return this.quantityElement ? this.quantityElement.value : 1;
    }
    onQuantityElementChange() {
      this.dispatchEvent(new CustomEvent('quantityChange', {detail: {"quantity":this.getQuantity()}}));
    }
  }
  customElements.define('product-main', ProductMain);

  class ComponentProductCardAtc extends ProductMain {
    constructor() {
      super()
      this.swatches = this.querySelector('.swatch-group')
      this.quickViewBtn = this.querySelector('.quick-view-trigger')
      this.addEventListener('variantChange', this.onVariantChange.bind(this));
      this.defaultImage = this.querySelector('.img.main').getAttribute('data-srcset');
      this.currentImageUrl = '';
      this.imageObserver = null;
      this.clickOutHandler = null;

      if (this.quickViewBtn) this.quickViewBtn.addEventListener('click', this.openQuickView.bind(this))

      this.optionsButton = this.querySelector('.atc-options');
      if (this.optionsButton) {
        this.optionsButton.addEventListener('click', this.openOptions.bind(this));
      }

      var self = this;
      if (self.classList.contains('colors-out')) {
        setTimeout(function() { //workaround on ajax call, the following code mistakenly inits ProductSwatch before ProductVariants
          self.colorSwatches = self.querySelector('product-swatch.color-swatches');
          if (self.colorSwatches) {
            self.querySelector('add-to-cart-form').insertAdjacentElement('afterbegin',self.colorSwatches);
          }
        }, 10);
      }
    }

    openQuickView(e) {
      e.preventDefault()
      $s.showLoadingOverlay();
      var qvUrl = this.quickViewBtn.dataset.url;
      $s.get({
        url: qvUrl,
        success: (html)=>{
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var section = doc.querySelector('.product-main-element').closest('.shopify-section');
          $s.openModal(section, 'product-quick-view');
          $s.globalEval(section);
        },
        always: (html)=>{
          $s.hideLoadingOverlay();
        }
      })
    }

    openOptions() {
      var container = this.querySelector('.atc-options-wrapper form');
      this.querySelector('.atc-options-wrapper').classList.add('open');
      $s.trapFocus(container);
      var self = this;
      if (!this.clickOutHandler) {
        this.querySelector('.close').addEventListener('click', this.closeOptions.bind(this));
      }
      this.clickOutHandler = function(evt) {
        if(container !== evt.target && !container.contains(evt.target)) {
          self.closeOptions.bind(self)();
        }
      }
      document.addEventListener('mousedown', this.clickOutHandler);
    }
    closeOptions() {
      this.querySelector('.atc-options-wrapper').classList.remove('open');
      document.removeEventListener('mousedown', this.clickOutHandler);
      $s.removeTrapFocus();
    }

    onVariantChange(event) {
      var image = event.detail.variant.featured_image;
      var img = this.querySelector('.img.main');
      var width = Math.ceil(img.width / 100) * 100;
      if (img.classList.contains('lazyload')) {
        img.setAttribute('data-srcset', image ? $s.imgUrlFilter(image.src, width+'x') : this.defaultImage);
      } else {
        this.currentImageUrl = image ? $s.imgUrlFilter(image.src, width+'x') : this.defaultImage;
        if (!this.imageObserver) {
          if (!img.classList.contains('lazyloaded')) {
            this.imageObserver = new MutationObserver(mutations => {
              if (img.classList.contains('lazyloaded')) {
                this.imageObserver.disconnect();
                this.imageObserver = null;
                img.setAttribute('srcset', this.currentImageUrl);
              }
            });
            var config = { attributes: true, attributeFilter: ['class']};
            this.imageObserver.observe(img, config);
          } else {
            img.setAttribute('srcset', this.currentImageUrl);
          }
        }
      }

    }
  }
  customElements.define('product-card-atc', ComponentProductCardAtc);
}

if(!customElements.get('product-buttons')) {
  class ProductButtons extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.dynamicButtons = this.querySelector('.shopify-payment-button');
      this.addToCartBtn = this.querySelector('.btn.add');

      this.mainElement.addEventListener('variantChange', (e)=>{
        if(e.detail.variant && e.detail.variant.available) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.remove('hide');
          }
          //this.addToCartBtn.style.display = '';
          if(this.addToCartBtn.querySelector('.btn.add .btn-price')){
            this.addToCartBtn.querySelector('.btn.add .btn-price').innerHTML = ` - ${$s.formatMoney(e.detail.variant.price)}`;
          }
          this.querySelector('.sold-out-message').style.display = 'none';
      	} else {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          this.querySelector('.btn.add').style.display = 'none';
          this.querySelector('.sold-out-message').style.display = '';
      	}
      });
    }
  }
  customElements.define('product-buttons', ProductButtons);
}

if(!customElements.get('product-gallery') && !customElements.get('product-thumbs')) {
  class ProductMedia extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.itemsWrapper = this.querySelector(':scope > .images-wrapper');
      this.desktopStyle = this.dataset.desktop;
      this.mobileStyle = this.dataset.mobile;
      this.slider = false;

      this.mainElement.addEventListener('variantChange', this.onVariantChange.bind(this))
      window.addEventListener('mediaChange', this.onMediaChange.bind(this))
      setTimeout(()=>{
        this.onMediaChange();
      }, 10);
    }

    filterMedia(variant) {
      this.mainElement.productData.media.forEach((media)=>{
        var show = true;
        if(media.alt && media.alt!="") {
          var filter = media.alt.split(';');
          filter.forEach((f)=>{
            if(show) {
              var key = f.split(':')[0];
              var values = f.split(':')[1];
              var optionIndex = this.mainElement.productData.options.findIndex(x=>x==key);
              if(optionIndex>=0) {
                var found = false;
                values.split(',').forEach((value)=>{
                  if(variant.options[optionIndex]==value) {
                    found = true;
                  }
                });
                show = found;
              }
            }
          });
        }
        if(show) {
          this.querySelector('[data-media-id="'+media.id+'"]').style.display = 'block';
        } else {
          this.querySelector('[data-media-id="'+media.id+'"]').style.display = 'none';
        }
      });
      if(this.slider) {
        this.slider.refresh();
      }
    }

    onVariantChange() {
    }

    onMediaChange() {
    }

    initSlider() {
    }

    removeSlider() {
      if(this.slider) {
        this.slider.destroy();
        this.slider = false;
        this.classList.remove('keen');
        this.itemsWrapper.classList.remove('keen-slider');
        this.querySelectorAll(':scope > div').forEach((slide)=>{
          slide.classList.remove('keen-slider-slide')
        });
      }
    }

    showItem(mediaId, animate=true) {
      if(this.slider) {
        var index = Array.from(this.itemsWrapper.querySelectorAll(':scope > div'))
          .filter(x => $s.isVisible(x))
          .findIndex(x => x.dataset.mediaId == mediaId);
        if(animate) {
          this.slider.moveToSlideRelative(index, true);
        } else {
          this.slider.moveToSlideRelative(index, true, 0);
        }
      }
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentMediaId: mediaId
        }
      }));
    }
    
  }

  class ProductGallery extends ProductMedia {
    constructor() {
      super();

      if(!this.closest('.tingle-modal')) {
        this.querySelectorAll('[data-file]').forEach((media)=>{
          media.addEventListener('click', (e)=>{
            var visibleItems = [];
            this.querySelectorAll('[data-media-id]').forEach((obj)=>{
              if($s.isVisible(obj)) {
                let element  = obj.querySelector('[data-file], video, iframe');
                if(element) {
                  visibleItems.push(element);
                }
              }
            });
            $s.photoSwipe(visibleItems, media);
          });
        });
        //3D Models
        this.querySelectorAll('[data-media-id].model-wrap').forEach((model)=>{
          model.addEventListener('click', (e)=>{
            $s.photoSwipe([model.querySelector('template').content.firstElementChild]);
          });
        });
      }
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      var animate = e.detail.animate;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant)
        if(variant.featured_media) {
          this.showItem(variant.featured_media.id, animate)
        }
      }
    }

    onMediaChange() {
      if($s.media.isSmall || this.desktopStyle=='carousel') {
        this.initSlider();
      } else {
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll(':scope > div').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });

        var breakpoints = {};
        if(this.mobileStyle=='dots') {
          breakpoints['(max-width: '+window.breakpoints.small+')'] = {
            dots: this.querySelector('.keen-dots')
          }
        }
        if(this.querySelector('.keen-arrow')) {
          breakpoints['(min-width: '+(parseInt(window.breakpoints.small) + 1) +'px)'] = {
            prevButton: this.querySelector('.keen-arrow.prev'),
            nextButton: this.querySelector('.keen-arrow.next')
          }
        }

        if(document.querySelector('.tingle-modal.product-quick-view')){
          breakpoints['(min-width: '+(parseInt(window.breakpoints.small) + 1) +'px)'] = {
            dots: this.querySelector('.keen-dots'),
            prevButton: false,
            nextButton: false
          }
        }

        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: true,
          wheel: false,
          slideChanged: (keen)=>{
            $s.pauseAllMedia(this);
            //this.dispatchEvent(new CustomEvent('slideChanged', {detail: keen}));
          },
          breakpoints,
          created: ()=>{
            if(document.querySelector('.tingle-modal.product-quick-view')){
              setTimeout(()=>{
                window.dispatchEvent(new Event('resize'));
              }, 300);
            }
          }
        });
      }
    }
  }
  customElements.define('product-gallery', ProductGallery);

  class ProductThumbs extends ProductMedia {
    constructor() {
      super();
      this.mainGallery = this.mainElement.querySelector('product-gallery');
      this.itemsWrapper = this.querySelector(':scope > div'); // this is your thumb wrapper

      this.querySelectorAll('[data-media-id]').forEach((media)=>{
        media.addEventListener('click', (e)=>{
          this.mainGallery.showItem(media.dataset.mediaId);
        });
      });

      this.mainGallery.addEventListener('slideChanged', (e) => {
        const currentMediaId = e.detail.currentMediaId;
        if (!currentMediaId) return;
      
        this.querySelectorAll('.current-slide').forEach(el => el.classList.remove('current-slide'));
      
        const activeThumb = this.querySelector(`[data-media-id="${currentMediaId}"]`);
        if (activeThumb) {
          activeThumb.closest('.thumb-wrap').classList.add('current-slide')
        }
      });

      // Trigger initial highlight for the first visible media
      const firstVisibleMedia = Array.from(this.mainGallery.itemsWrapper.querySelectorAll('[data-media-id]'))
        .find(el => $s.isVisible(el));

      if (firstVisibleMedia) {
        const mediaId = firstVisibleMedia.dataset.mediaId;
        // Simulate the slideChanged event so thumbs update
        this.mainGallery.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentMediaId: mediaId
          }
        }));
      }
      
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant)
      }
    }

    onMediaChange() {
      if(($s.media.isSmall && this.mobileStyle=='thumbnails') || ($s.media.isMediumUp && this.desktopStyle=='carousel' )) {
        this.style.display = 'block';
        this.initSlider();
      } else {
        this.style.display = 'none';
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider && this.itemsWrapper) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll(':scope > div').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });
        var breakpoints = {};
        breakpoints['(max-width: '+window.breakpoints.medium+')'] = {
          slidesPerView: 4,
          spacing: 10
        }
        breakpoints['(max-width: '+window.breakpoints.small+')'] = {
          slidesPerView: 5,
          spacing: 10
        }
        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: true,
          centered: true,
          slidesPerView: 7,
          spacing: 15,
          prevButton: this.querySelector('.keen-arrow.prev'),
          nextButton: this.querySelector('.keen-arrow.next'),
          breakpoints
        });
      }
    }
  }
  customElements.define('product-thumbs', ProductThumbs);
}

if(!customElements.get('product-price')) {
  class ProductPrice extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.dealElement = this.querySelector('.deal');
      this.retailElement = this.querySelector('.retail');

      ['variantChange','quantityChange','sellingPlanChange'].forEach((event)=>{
        this.mainElement.addEventListener(event, (e)=>{
          var data = e.detail.variant || e.detail.sellingPlan;
          if(!data) {
            data = this.mainElement.getCurrentVariant();
          }
        	if(data) {
        		this.dealElement.innerHTML = $s.formatMoney(data.price * this.mainElement.getQuantity());

            if(data.compare_at_price > data.price) {
              this.retailElement.classList.remove('hide');
              this.retailElement.innerHTML = $s.formatMoney(data.compare_at_price * this.mainElement.getQuantity());
            } else {
              this.retailElement.classList.add('hide');
              this.retailElement.innerHTML = '';
            }
        	} else {
        		this.dealElement.innerHTML = '';
            this.retailElement.innerHTML = '';
        	}
        });
      });
    }
  }
  customElements.define('product-price', ProductPrice);
}

if(!customElements.get('product-variants')) {
  class ProductVariants extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.variantInput = this.querySelector('[data-variant-id]');

      this.bindOptions();
      setTimeout(()=>{
        this.variantChange(this.getCurrentVariant(), false);
      }, 10);
    }

    getCurrentVariant() {
      return this.mainElement.productData.variants.find(x=>x.id==this.variantInput.value)
    }

    setVariant(variant) {
      if(typeof variant !== 'object') {
        variant = this.mainElement.productData.variants.find(x=>x.id==variant);
      }
      if(variant) {
        this.refreshOptions(-1, variant);
        this.variantChange(variant);
      }
    }

    variantChange(variant, animate=true) {
      if(variant) {
        this.variantInput.value = variant.id;
      } else {
        this.variantInput.value = '';
      }
      this.previousVariant = variant;
      this.variantInput.dispatchEvent(new Event('change', {bubbles: true}))
      this.mainElement.dispatchEvent(new CustomEvent('variantChange', {detail: {variant, animate}}));
    }

    calculateNewVariant(optionChanged, value) {
      var newVariants = this.mainElement.productData.variants;
      this.mainElement.productData.options.forEach((option, index)=>{
        if(optionChanged==index) {
          newVariants = newVariants.filter(x=>x.options[index]==value);
        } else {
          var tmpNewVariants = newVariants.filter(x=>x.options[index]==this.previousVariant.options[index]);
          if(tmpNewVariants.length==0) {
            tmpNewVariants = newVariants.filter(x=>x.options[index]==newVariants[0].options[index]);
          }
          newVariants = tmpNewVariants;
        }
      });
      return newVariants[0];
    }

    bindOptions() {
      this.mainElement.querySelectorAll('[data-option]').forEach((element)=>{
        element.addEventListener('change', (e)=>{
          let optionIdx = element.dataset.option-1;
          let variant = this.calculateNewVariant(optionIdx, e.target.value);
          this.refreshOptions(element.dataset.option-1, variant);
          this.variantChange(variant);
        });
      });
    }

    getOptionValues(currentVariant) {
      var options = [];
      this.mainElement.productData.options.forEach((option, index)=>{
        if(index==0) {
          var optionValues = this.mainElement.productData.variants.map((variant)=>{return {
            value: variant.options[index],
            available: variant.available,
            id: variant.sku
          }});
        }
        if(index==1) {
          var optionValues = this.mainElement.productData.variants.filter(x=>x.options[0]==currentVariant.option1).map((variant)=>{return {
            value: variant.options[index],
            available: variant.available,
            id: variant.sku
          }});
        }
        if(index==2) {
          var optionValues = this.mainElement.productData.variants.filter(
            x=>x.options[0]==currentVariant.option1 && x.options[1]==currentVariant.option2
          ).map((variant)=>{return {
            value: variant.options[index],
            available: variant.available,
            id: variant.sku
          }});
        }
        var optionValuesUnique = [];
        optionValues.forEach((option, key)=>{
          if(!optionValuesUnique.find(x=>x.value==option.value)) {
            if(option.available) {
              optionValuesUnique.push(option);
            } else {
              if(!optionValues.find((x,y)=>y!=key && x.available && x.value==option.value)) {
                optionValuesUnique.push(option);
              }
            }
          }
        });
        options.push(optionValuesUnique);
      });
      return options;
    }

    refreshOptions(updateOptionIndex=-1, currentVariant) {
      var optionValues = this.getOptionValues(currentVariant);
      this.mainElement.querySelectorAll('[data-option]').forEach((element)=>{
        let index = element.dataset.option - 1;
        if(index > updateOptionIndex) {
          element.buildOptions(optionValues[index], currentVariant.options[index]);
        }
        var optionValueElement = element.querySelector('.option-value');
        if(optionValueElement) {
          optionValueElement.innerHTML = currentVariant.options[index];
        }
      });
    }
  }
  customElements.define('product-variants', ProductVariants);
}

if(!customElements.get('product-swatch')) {
  class ProductSwatch extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;

      this.buildOptionSelector();
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber - 1];
      var defaultValue = currentVariant.options[this.optionNumber - 1];
      var optionElement = document.createElement('div');
      var sizeGuideTrigger = false;
      var productId = this.dataset.productId;

      if (this.dataset.sizeGuide) {
        sizeGuideTrigger = `<button type="button" class="size-guide-trigger-${productId}">Size Guide</button>`;
      }

      var html = `
        <div class="option-name flex justify-content-between">
          ${(this.label === 'Color' || this.label === 'Metal') ? `${this.label}: <span class="color-name">${defaultValue}</span>` : this.label}
          ${sizeGuideTrigger ? sizeGuideTrigger : ''}
        </div>
        <div class="swatch-group flex flex-wrap"></div>
      `;

      this.innerHTML = html;
      this.buildOptions(optionValues, defaultValue);

      const sizeGuideModalTrigger = this.querySelector(`.size-guide-trigger-${productId}`);
      const sizeGuideModalContent = document.getElementById(`size-guide-modal-${productId}`);
      if (sizeGuideTrigger && sizeGuideModalContent) {
        sizeGuideModalTrigger.addEventListener('click', () => {
          $s.openModal(sizeGuideModalContent, 'size-guide');
        });
      }
    }

    buildOptions(options, defaultValue) {
    	var html = '';
  		options.forEach((option, index)=>{
        var optionNameHandle = $s.handleize(this.label);
        var optionValueHandle = $s.handleize(option.value);
  			html += `
          <div class="swatch" data-available="${option.available}" data-id="${option.id}">
            <input type="radio" id="swatch-${this.optionNumber}-${option.value}-${this.mainElement.sectionId}" name="swatch-${this.optionNumber}-${this.mainElement.sectionId}" value="${option.value}" />
  				  <label for="swatch-${this.optionNumber}-${option.value}-${this.mainElement.sectionId}">
              <div class="label-inner ${optionNameHandle}-${optionValueHandle}">
              	<span>${option.value}</span>
              </div>
            </label>
          </div>
  			`;
  		});
  		var group = this.querySelector('.swatch-group');
  		group.innerHTML = html;

  		if(defaultValue && group.querySelector('input[value="'+defaultValue+'"]')) {
  			//group.querySelector('input[value="'+defaultValue+'"]').checked = true;
  		} else {
  			//group.querySelector('input').checked = true;
  		}
    }
  }
  customElements.define('product-swatch', ProductSwatch);
}

if(!customElements.get('product-dropdown')) {
  class ProductDropdown extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;

      this.buildOptionSelector();
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];

      var optionId = 's-' + this.mainElement.sectionId+'-option-'+this.optionNumber;
      var optionElement = document.createElement('div');
      var html = `
        <label class="option-name" for="${optionId}">${this.label}</label>
        <select id="${optionId}"></select>
      `;
      this.innerHTML = html;
      this.buildOptions(optionValues, defaultValue);
    }

    buildOptions(options, defaultValue) {
    	var html = '';
  		options.forEach((option, index)=>{
  			let soldOut = (!option.available ? ' - Sold Out' : '');
  			html += `<option value="${option.value}">${option.value}${soldOut}</option>`;
  		});
  		var select = this.querySelector('select');
  		select.innerHTML = html;

  		if(defaultValue) {
    		var newValueIndex = Array.from(select.options).findIndex(x=>x.value==defaultValue);
    		if(newValueIndex>=0) {
    			select.selectedIndex = newValueIndex;
    		}
  		}
    }
  }
  customElements.define('product-dropdown', ProductDropdown);
}

if(!customElements.get('product-model')) {
  class ProductModel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = document.querySelector('.product-main-element[data-product-id="'+this.dataset.productId+'"]');

      window.Shopify.loadFeatures([{
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXr.bind(this)
      }]);
    }

    setupShopifyXr() {
      if(!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', ()=>{
          this.setupShopifyXr();
        });
      } else {
        window.ShopifyXR.addModels(this.mainElement.productData.media.filter(x=>x.media_type=='model'));
        setTimeout(()=>{
          window.ShopifyXR.setupXRElements();
        }, 100);
      }
    }
  }
  customElements.define('product-model', ProductModel);
}
/*
REF: FEATURE PICKUP AVAILABILITY
if(!customElements.get('pickup-availability')) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('product-main');

      this.mainElement.addEventListener('variantChange', (e)=>{
        if(e.detail.variant && e.detail.variant.available) {
          this.fetchAvailability(e.detail.variant.id);
        } else {
          this.innerHTML = '';
        }
      });
    }

    fetchAvailability(variantId) {
      let rootUrl = routes.root;
      if (!rootUrl.endsWith("/")) {
        rootUrl = rootUrl + "/";
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup_availability`;

      $s.get({
        url: variantSectionUrl,
        success: (data)=>{
          this.innerHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('.shopify-section').innerHTML;
          this.bindEvents();
        },
        error: ()=>{
          this.innerHTML = '';
        }
      });
    }

    bindEvents() {
      let button = this.querySelector('button');
      if(button) {
        button.addEventListener('click', ()=>{
          $s.openModal(this.querySelector('.pickup-availability-info'), 'test');
        });
      }
    }
  }
  customElements.define('pickup-availability', PickupAvailability);
}
*/


